export default __webpack_public_path__ + "media/3876f35945587fb8357aec90b9fb184902686855e9dc572e3856945f926d6f1b.svg";